import { Banner } from "@/components/flexkit/Banner";
import { cn } from "@/components/podkit/lib/cn";

function FreeCreditsPromotionBanner({ className }: { className?: string }) {
    return (
        <Banner
            className={cn("text-content-primary lg:text-lg", className)}
            text="Get $100 in free credits if you sign up today."
            variant="info"
            role="alert"
            aria-live="assertive"
            LeadingIcon={null}
        />
    );
}

export default FreeCreditsPromotionBanner;
